import Vue from 'vue'
import Flickity from 'flickity'
import Stickyfill from 'stickyfilljs'
import { ARROW_SHAPE } from '../components/slider'
import BookingSpaceSlotPicker from '../vue/BookingSpaceSlotPicker'

const SELECTORS = Selectors({
  page: 'booking-space-detail-page',
  sidebar: 'booking-space-sidebar',
  mediaSlider: 'booking-space-media-slider',
  mediaThumbnailSlider: 'booking-space-media-thumbnail-slider',
  floorplanTrigger: 'booking-space-floorplan-trigger',
  map: 'booking-space-map'
})

const $page = document.querySelector(SELECTORS.asClass('page'))
const $sidebar = document.querySelector(SELECTORS.asClass('sidebar'))
const $mediaSlider = document.querySelector(SELECTORS.asClass('mediaSlider'))
const $mediaThumbnailSlider = document.querySelector(SELECTORS.asClass('mediaThumbnailSlider'))
const $floorplanTrigger = document.querySelector(SELECTORS.asClass('floorplanTrigger'))
const $map = document.querySelector(SELECTORS.asClass('map'))
const $slotPickerEl = document.getElementById('booking-space-slot-picker')

const fn = {
  init: () => {
    if ($slotPickerEl) {
      window._slotPicker = {
        controllerUrl: $slotPickerEl.dataset.controllerUrl,
        bookingSpaceId: $slotPickerEl.dataset.bookingSpaceId,
        bookingRequestUrl: $slotPickerEl.dataset.bookingRequestUrl
      }

      new Vue({
        el: $slotPickerEl,
        render: h => h(BookingSpaceSlotPicker)
      })
    }

    if ($mediaSlider) {
      fn.setupMediaSlider()
    }

    if ($floorplanTrigger) {
      $floorplanTrigger.addEventListener('click', fn.handleFloorplan)
    }

    if ($map) {
      fn.setupMap()
    }

    Stickyfill.add($sidebar)
  },

  setupMediaSlider: () => {
    $mediaSlider.classList.add('is-init')
    $mediaSlider.offsetHeight

    const slider = new Flickity($mediaSlider, {
      arrowShape: ARROW_SHAPE,
      wrapAround: true,
      draggable: '>1',
      imagesLoaded: true
    })

    slider.on('resize', function () {
      const isSingleSlide = this.slides.length < 2
      const hasPrevNextButtons = this.options.prevNextButtons

      this.element.classList.toggle('is-single-slide', isSingleSlide)
      this.element.classList.toggle('has-buttons', hasPrevNextButtons)
    })

    setTimeout(slider.resize.bind(slider), 250)

    if ($mediaThumbnailSlider) {
      new Flickity($mediaThumbnailSlider, {
        cellAlign: 'left',
        groupCells: '100%',
        wrapAround: true,
        draggable: false,
        asNavFor: SELECTORS.asClass('mediaSlider'),
        prevNextButtons: false,
        pageDots: false
      })
    }
  },

  handleFloorplan: () => {
    const lightGallery = window.lightGallery

    lightGallery($floorplanTrigger, {
      dynamic: true,
      dynamicEl: JSON.parse($floorplanTrigger.dataset.images),
      download: true,
      thumbnail: false
    })
  },

  setupMap: () => {
    const google = window.google
    const data = JSON.parse($map.dataset.json)
    const center = new google.maps.LatLng(data.lat, data.lng)

    const mapOptions = {
      center,
      zoom: 15,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      scrollwheel: false,
      styles: [
        {
          'featureType': 'poi',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        }
      ]
    }

    const map = new google.maps.Map($map, mapOptions)
    const bounds = new google.maps.LatLngBounds()

    google.maps.event.addListenerOnce(map, 'tilesloaded', () => {
      let size = new google.maps.Size(56, 80)

      if (window.matchMedia('(min-width: 1024px)').matches) {
        size = new google.maps.Size(77, 110)
      }

      if (window.matchMedia('(min-width: 1440px)').matches) {
        size = new google.maps.Size(103, 148)
      }

      const markerImage = {
        url: data.mapMarkerURL,
        scaledSize: size
      }

      const marker = new google.maps.Marker({
        map: map,
        title: data.title,
        animation: google.maps.Animation.DROP,
        position: new google.maps.LatLng(data.lat, data.lng),
        panposition: new google.maps.LatLng(data.lat, data.lng),
        icon: markerImage
      })

      google.maps.event.addListener(marker, 'click', () => {
        window.open(data.mapLink)
      })

      bounds.extend(marker.getPosition())
    })
  }
}

export default {
  can: () => $page,
  run: fn.init
}
